import React, { useEffect } from 'react';
import { string, func, bool } from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { CtaSection } from '../common/CtaSection';
import { buildSamLink } from '../../utils/home-services-cta-utils';
import { dataModel } from './dataModel';

const GccCarpetSamCta = ({
  itemId, onClick, target, hideLabel
}) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('schedule-a-measure.ready'); }, []);

  const { data } = useDataModel('product', {
    variables: {
      itemId
    },
    ssr: true,
  });

  const { product: {
    identifiers: {
      specialOrderSku,
      storeSkuNumber
    } = {}
  } = {} } = data || {};

  if (!itemId) {
    return null;
  }

  return (
    <CtaSection
      buttonText="Get Estimate"
      buttonLink={`https://custom.homedepot.com/flooring/${itemId}`}
      openContentInDrawer={false}
      onClick={onClick}
      label="Schedule a Measure Only"
      labelLink={buildSamLink(specialOrderSku || storeSkuNumber)}
      hideLabel={hideLabel}
      hideContactInfo
      target={target}
      dataComponent="GccCarpetSamCta"
    />
  );
};

GccCarpetSamCta.displayName = 'GccCarpetSamCta';

GccCarpetSamCta.dataModel = dataModel;

GccCarpetSamCta.propTypes = {
  itemId: string.isRequired,
  onClick: func,
  target: string,
  hideLabel: bool
};

GccCarpetSamCta.defaultProps = {
  onClick: () => {},
  target: '_blank',
  hideLabel: false
};

export { GccCarpetSamCta };
